import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MsalGuard } from "@azure/msal-angular";
import { LoginComponent } from './auth/login/login.component';
@NgModule({
    imports: [
        RouterModule.forRoot(
            [
                {
                    path: 'login',
                    component: LoginComponent
                },
                { path: '', redirectTo: 'login', pathMatch: 'full' },
                {
                    path: '',
                    loadChildren: () => import('./main/main.module').then((m) => m.MainModule),
                    canLoad: [MsalGuard],
                },
                { path: '**', redirectTo: 'login' },
            ],
            {
                useHash: true,
                // Don't perform initial navigation in iframes ort popups, except for logout
                initialNavigation: 'enabled',
                relativeLinkResolution: 'legacy'
            }
        ),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule { }
